import React from "react";

const CheckmarkCircle: React.FC<React.SVGProps<SVGSVGElement>> = ({ width = 16, height = 16, ...props }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Checkmark circle icon"
			{...props}
		>
			<path
				d="M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM15.4277 8.51562C15.6953 8.19949 16.1682 8.1602 16.4844 8.42773C16.8005 8.69531 16.8398 9.1682 16.5723 9.48438L11.0723 15.9844C10.9368 16.1444 10.7407 16.2403 10.5312 16.249C10.3217 16.2577 10.118 16.1786 9.96973 16.0303L6.96973 13.0303C6.67684 12.7374 6.67684 12.2626 6.96973 11.9697C7.26262 11.6768 7.73738 11.6768 8.03027 11.9697L10.4541 14.3936L15.4277 8.51562Z"
				fill="#023409"
			/>
		</svg>
	);
};

export default CheckmarkCircle;